var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage31(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM17.5588 9.50027C17.8351 9.19167 17.8089 8.71752 17.5003 8.44123C17.1917 8.16493 16.7175 8.19113 16.4412 8.49973L13.0721 12.2629C12.3894 13.0254 11.9296 13.5363 11.5365 13.8667C11.1621 14.1814 10.9421 14.25 10.75 14.25C10.5579 14.25 10.3379 14.1814 9.96348 13.8667C9.5704 13.5363 9.11064 13.0254 8.42794 12.2629L7.55877 11.2921C7.28248 10.9835 6.80833 10.9573 6.49973 11.2336C6.19113 11.5099 6.16493 11.984 6.44123 12.2926L7.34753 13.3049C7.98338 14.0152 8.51374 14.6076 8.99835 15.0149C9.51099 15.4458 10.0639 15.75 10.75 15.75C11.4361 15.75 11.989 15.4458 12.5016 15.0149C12.9863 14.6076 13.5166 14.0152 14.1525 13.3049L17.5588 9.50027Z",
    fill: "#1B4DF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage31);
export default __webpack_public_path__ + "static/media/Image31.cb0e65963be51f32dba37d2e9e17a0ca.svg";
export { ForwardRef as ReactComponent };